import * as React from 'react'
import {useFela} from 'react-fela'
import {Theme} from '../../../../app/theme'
import {Breadcrumb, ReaderBreadcrumbsPanel} from '../../../../commons/components/header/ReaderBreadcrumbsPanel'
import {ReaderHeaderPanel} from '../../../../commons/components/header/ReaderHeaderPanel'
import {ReaderSubHeaderPanel} from '../../../../commons/components/header/ReaderSubHeaderPanel'
import {
  ReaderLayoutContext,
  ReaderLayoutContextValue,
} from '../../../../commons/layouts/reader-layout/ReaderLayoutContext'
import {DocumentInfo} from '../../../../commons/types/DocumentInfo'
import {DigitalLogo} from '../../../../digital/components/digital-logo/DigitalLogo'
import {bookPathEbook, bookPathOverview} from '../../../store/book.paths'

interface Props {
  bookTitle: string
  bookId: string
  documentInfo?: DocumentInfo
}

export const BookWebbookIdReaderHeaderPanel: React.FC<Props> = ({bookId, bookTitle, documentInfo}) => {
  const {theme} = useFela<Theme>()
  const {setHeaderHeight} = React.useContext<ReaderLayoutContextValue>(ReaderLayoutContext)
  React.useLayoutEffect(() => {
    const headerHeight = theme.layout.reader.headerHeight + theme.layout.reader.toolbarHeight
    setHeaderHeight(headerHeight)
  }, [setHeaderHeight, theme.layout.reader.headerHeight, theme.layout.reader.toolbarHeight])

  const logo = <DigitalLogo small />
  const breadcrumbs: Breadcrumb[] = [
    {name: 'Bücher', linkTo: bookPathOverview()},
    {name: bookTitle, linkTo: bookPathEbook(bookId, bookTitle)},
  ]
  if (documentInfo) {
    breadcrumbs.push({name: documentInfo.documentName!})
  }
  return (
    <>
      <ReaderHeaderPanel logo={logo} />
      <ReaderSubHeaderPanel height={theme.layout.reader.toolbarHeight}>
        <ReaderBreadcrumbsPanel breadcrumbs={breadcrumbs} />
      </ReaderSubHeaderPanel>
    </>
  )
}
